import { bodyLockToggle } from "./helpers/body-lock-toggle";

window.addEventListener('load', () => {

    let availableLightboxes = document.querySelectorAll('.feature-display-video-lightbox');

    if (availableLightboxes.length) {
        for ( let lightbox of availableLightboxes ) {
            let lightboxId = lightbox.dataset.associatedWith;
            let lightboxToggles = document.querySelectorAll('button[data-open-video-modal=' + lightboxId + ']');
            let lightboxBackdrop = lightbox.querySelector('.lightbox-backdrop');
            let lightboxClose = lightbox.querySelector('.lightbox-close');

            function closeLightBox() {
                lightbox.classList.add('opacity-0','pointer-events-none');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
                bodyLockToggle();
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0','pointer-events-none');
                }, 50);
                bodyLockToggle();
            }

            for (let lightboxToggle of lightboxToggles) {
                lightboxToggle.addEventListener('click', () => {
                    if (lightboxId === lightboxToggle.dataset.openVideoModal) {
                        openLightBox();
                    }
                });
            }

            if (lightboxBackdrop) {
                lightboxBackdrop.addEventListener('click', () => {
                    closeLightBox();
                });
            }

            if (lightboxClose) {
                lightboxClose.addEventListener('click', () => {
                    closeLightBox();
                });
            }
        }
    }
});
